import { WildberriesAdvantagesMetaModel } from './wildberriesAdvantages.model';

export const wildberriesAdvantagesMeta: WildberriesAdvantagesMetaModel = {
  title: 'Онлайн-курсы\nот проверенных школ',
};
